import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

const ControlPanelContainer = styled.div`
  padding: ${Spacing[5]};
`;

export default ControlPanelContainer;
